import { cn } from '@/lib/utils';
import { Skeleton } from '../Skeleton';
import { ShapeGroup } from './ShapeGroup';

interface TableSkeletonProps {
  cols: number;
  rows?: number;
  label?: string;
  className?: string;
}

/** The body of a table (rankings, match lists) in the table's own cell rhythm. */
export function TableSkeleton({ cols, rows = 5, label, className }: TableSkeletonProps) {
  return (
    <ShapeGroup label={label} className={cn('overflow-x-auto', className)}>
      <table aria-hidden="true" className="w-full border-collapse text-sm">
        <tbody>
          <Skeleton.TableRows cols={cols} rows={rows} />
        </tbody>
      </table>
    </ShapeGroup>
  );
}
